// extracted by mini-css-extract-plugin
export default {"formContent":"Filters_formContent__+50du","hide":"Filters_hide__zZBlV","column":"Filters_column__ynRO2","placeHolderShimmer":"Filters_placeHolderShimmer__I8fqu"};